import { ViewEditHSRouter } from './ViewEditHSRouter'

export const ViewEditHS = () => {
  return <ViewEditHSRouter />
}
